// Bayut regional sites share the same listing-type taxonomy as Bayut KSA, so the land
// property-type check is reused. Exposed on tenantData so the listing drawer can hide
// beds/baths rows for land listings.
import { isLandPropertyType } from '../../bayut/data/listing-form-data';

export default {
  isLandPropertyType,
};
